<template>
    <div style="margin: 0px; padding: 0px;">
        <sys-select-base 
            :model.sync="selected"
            :items="items"
            :loading="loading"
            :label="label"
            :error="error"
            :errors="errors"
            @onShowForm="showForm = true"
            :clearable="clearable"
            :showAdd="showAdd"
            :multiple="multiple"
            :outlined="outlined"
            :auto-complete="autoComplete"
            @change="$emit('change', $event)"
            @input="$emit('input', $event)"
            :dense="dense"
            :hideDetails="hideDetails"
            :class="classe"
            :classe="classe"
            :background-color="backgroundColor"
            :color="color"
        />
        <sys-register-occupation-area @onCompleted="newItem" :model="{}" v-bind:show.sync="showForm" />
    </div>
</template>

<script>

import { mapActions, mapState } from 'vuex'

export default {
    name: 'SysSelectOccupationArea',
    data: () => ({
        items: [],
        loading: false,
        selected: null,
        showForm: false
    }),
    computed: {
        ...mapState('auth', ['acesso'])
    },
    mounted(){
        
    },
    created() {
        this.getItems();
    },
    props: {
        
        error: {
            type: Boolean,
            default: false
        },
        errors: {
            type: Array,
        },
        label: {
            type: String,
            required: true
        },
        clearable: {
            type: Boolean,
            default: false
        },
        showAdd: {
            type: Boolean,
            default: false
        },
        model: {
        
        },
        bigOccupationAreaId: {

        },
        multiple: {
            type: Boolean,
            default: false
        },
        outlined: {
            type: Boolean,
            default: false
        },
        autoComplete: {
            type: Boolean,
            default: false
        },
        dense: {
            type: Boolean,
            default: false
        },
        hideDetails: {
            type: [Boolean,String],
            default: false
        },
        classe: {

        },
        backgroundColor: {},
        color: {},
        
    },
    watch: {
        
        selected(val){
            this.$emit('update:model', val);
        },
        
        model(val){
            this.selected = val;
        },

        bigOccupationAreaId(val){
            this.getItems();
        }
    },
    methods: {
        ...mapActions('occupationArea', ['ActionFindOccupationAreas']),        
        
        async getItems() {

            this.loading = true;

            var payload =  {
                find_columns: {
                    active: 1,
                },
                column_order: 'name',
            }

            if(this.bigOccupationAreaId){
                payload.find_columns.big_occupation_area_id = this.bigOccupationAreaId;
            }

            await this.ActionFindOccupationAreas(payload)
                    .then((res) => {
                        this.items = res.data;
                        this.selected = this.model;
                    })
                    .finally(() => {
                        this.loading = false;
                    })
        },

        newItem(item){
            
            if(item){
                this.items.push(item);
                this.selected = item.id;
                this.showForm = false;
            }
        }
    },
    
}
</script>